export const spacing = {
  1.5: {
    xs: 1.25,
    md: 1.5
  },

  2: {
    xs: 1.5,
    sm: 1.75,
    md: 2
  },

  3: {
    xs: 1.5,
    sm: 2,
    md: 3
  },
  4: {
    xs: 2,
    sm: 3,
    md: 4
  }
};
